export default "__VITE_ASSET__jOpl$eSr__"